export const regExpFindUnderscore = /_/g;

const regexMap = {
  numbers: /^(([0-9]*)|(([0-9]*)\.([0-9]*)))$/,
  email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d$@!%*?&]{8,}/,
  emptyString: /\S+/,
  zipcode: /\d{5}/, // zip code USA has 5 digits
  creditCardStripSymbols: /[-\s]/g,
  cvc: /^\d{3,4}$/, // CVC number is three or four digits code
  url: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/,
  integerGreaterThanZero: /^[1-9]\d*$/
};

export default regexMap;



// WEBPACK FOOTER //
// ./src/constants/regExps.js